import jwt from 'jwt-decode';
import { User } from '../components/utilities/RouteGuard';

export const getUser = (): User | null => {
  const token = sessionStorage.getItem('token');
  return (token && jwt(token)) || null;
};
